import styled, { css,keyframes } from 'styled-components'

export const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${({ theme }) => theme.app.background};
  padding: ${({ isMobile }) => (isMobile ? '10px 24px' : '12px 20px')} ;
  height: 64px;
  gap: 20px;
  border-bottom: ${({ isMobile }) => (isMobile ? 'none' : '1px solid #222')};
  position: sticky;
  top: 0;
  z-index: 999;

  @media (max-width: 768px) {
    padding: 10px 14px;
    margin-right: 0px;
  }
`

export const Logo = styled.div`
  display: flex;
  align-items: center;
  cursor: 'pointer';
`

export const LogoImage = styled.img`
  // width: 81.28px;
  // height: 32px;
`

export const SearchContainer = styled.form`
  display: flex;
  align-items: center;
  border: 1px solid #344054;
  border-radius: 4px;
  flex: 1;
  max-width: 350px;
  height: 40px;
  width: 350px;
  @media (max-width: 768px) {
    display: none;
  }
  ${({ $isFocused, theme }) =>
    $isFocused &&
    `
    border: 1px solid ${theme.colors.Blue};
    box-shadow: 0 0 5px ${theme.colors.Blue}50;
  `}
`

export const SearchInput = styled.input`
  flex: 1;
  background: transparent;
  border: none;
  outline: none;
  color: ${({ theme }) => theme.app.text};
  font-size: 14px;
  padding: 0 8px;

  &::placeholder {
    color: ${({ theme }) => theme.colors.MidGray};
  }
`

export const Credits = styled.div`
  color: ${({ theme }) => theme.app.text};
  font-size: 10px;
  margin-right: 0;
  white-space: nowrap;
`

export const Creditsbadge = styled.div`
  display: flex;
  align-items: center;
  background: #fb8500;
  border-radius: 50px;
  padding: 6px 12px;
  color: white;
  font-size: 14px;
`

export const UserInfo = styled.div`
  display: flex;
  align-items: center;
`

export const Avatar = styled.img`
  width: 25px;
  height: 25px;
  border-radius: 50%;
  object-fit: cover;
`

export const ProfileImage = styled.img`
  width: ${({ isMobile }) => (isMobile ? '32px' : '40px')};
  height: ${({ isMobile }) => (isMobile ? '32px' : '40px')};
  border-radius: 50%;
  object-fit: cover;
  cursor: pointer;
  border: ${({ theme }) => `1px solid ${theme.app.settingCardBg}`};
`

export const UserDetails = styled.div`
  display: flex;
  flex-direction: column;
`

export const SubIcon = styled.img`
  height: 40px;
  width: 40px;
  border-radius: 50px;
  filter: ${({ theme }) => theme.app.iconFilter};
  transition: transform 0.2s;
  cursor: pointer;

  ${({ avatarMargin }) =>
    avatarMargin &&
    css`
      margin-left: 10px;
    `};
`

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-right: 0px;
`

export const ProfileContainer = styled.div`
  position: relative;
  display: inline-block;
`

export const CreditsBadgeOverlay = styled.div`
  position: absolute;
  background:${({theme})=>theme.app.bgLight};
  color: ${({ theme }) => theme.app.text};
  font-size: 10px;
  font-weight: bold;
  display: flex;
  height: 14px;
  align-items: center;
  padding-right: 5px;
  border-radius: 10px;

  ${({ isMobile }) =>
    isMobile
      ? `
        bottom: -6px;
        right: 50%;
        transform: translate(50%, 0);
        height: 15px
      `
      : `
        top: 50%;
        right: 0;
        transform: translate(70%, -50%);
      `}
`

export const RecentSearchesPopup = styled.div`
  position: absolute;
  top: 40px;
  left: 0;
  width: 100%;
  max-height: 300px;
  background-color: ${({ theme }) => theme.app.background};
  border-radius: 16px;
  overflow-y: auto;
  z-index: 2000;
  padding: 0px 15px;
  border: 0.2px solid ${({ theme }) => theme.app.inputBorder};
`

export const RecentSearchItem = styled.div`
  display: flex;
  align-items: center;
  padding: 5px 0;
  cursor: pointer;
`

export const RecentSearchText = styled.span`
  color: ${({ theme }) => theme.app.iconlabel};
  font-size: 14px;
  margin-left: 8px;
  text-align: left;
`

export const RecentSearchIcon = styled.img`
  width: 32px;
  height: 32px;
`

export const SearchInputWrapper = styled.div`
  position: relative;
`

export const DropdownArrow = styled.span`
  color: white;
  font-size: 12px;
  margin-left: 40px;
  transition: transform 0.2s ease;
  ${({ isOpen }) => isOpen && 'transform: rotate(180deg);'}
`

export const DropdownMenu = styled.div`
  position: absolute;
  top: 50px;
  right: 0;
  background-color: ${({ theme }) => theme.app.background};
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  min-width: 150px;
  z-index: 3000;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: column;
`

export const DropdownItem = styled.div`
  padding: 10px 16px;
  color: ${({ theme }) => theme.app.text};
  font-size: 14px;
  cursor: pointer;
`
export const RewardWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 8px 14px;
  background-color:${({theme})=>theme.app.bgLight};
  border-radius: 999px;
`
export const RewardTextContainer = styled.span`
  margin-left: 5px;
  font-size: 14px;
  font-weight: 600;
  color: ${({theme})=> theme.app.text};
`
export const SelectedLang = styled.div`
  text-transform: uppercase;
  margin-left: 3px;
  cursor: pointer;
  font-size: 14px;
  color:${({theme})=>theme.app.iconColor};
  font-weight:500;
`

export const LangWrapper = styled.div`
  display: flex;
  position: relative;
  align-items: center;
  padding: 8px 10px;
  border-radius: 18px;
  svg path{
  stroke:${({theme})=>theme.app.iconColor}
  }
   &:hover {
    background:${({theme})=>theme.app.iconHoverBg};
    color: ${({ theme }) => theme.app.text};
    ${SelectedLang} {
      color: ${({ theme }) => theme.app.text};
    }
  }

  &:hover svg path {
    stroke: ${({ theme }) => theme.app.text};
  }
`
export const DashbordIconWrapper=styled.div`
 display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 8px;
   svg path{
  stroke:${({theme})=>theme.app.iconColor}
  }
   &:hover svg path {
    stroke: ${({ theme }) => theme.app.text};
  }
 &:hover {
     background:${({theme})=>theme.app.iconHoverBg};
  }
`

export const InfoWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
   svg path{
  stroke:${({theme})=>theme.app.iconColor}
  }
   &:hover {
    background:${({theme})=>theme.app.iconHoverBg};
    color: ${({ theme }) => theme.app.text};
  
  }

  &:hover svg path {
    stroke: ${({ theme }) => theme.app.text};
  }
`

export const LanguageDropdown = styled.div`
  position: absolute;
  top: calc(100% + 8px); /* Show below the trigger */
  right: 0;

  background: ${({ theme }) => theme.app.dashboardBG};
  border-radius: 6px;
  min-width: 120px;
  padding: 6px 0;
  text-align: left;
  z-index: 9999;
  border: 1px solid #27272a;

`

export const LangMenu = styled.div`
    font-size: 14px;
    cursor: pointer;
    color: ${({ theme }) => theme.app.text};

    &:hover {
      background: ${({ theme }) => theme.app.dashboardCardsBG};
    }
`
export const SubMenu = styled.div`
    color: ${({ theme }) => theme.app.iconlabel};
`

const bellShake = keyframes`
  0%,
  100% {
    transform: rotate(0);
  }

  20% {
    transform: rotate(8deg);
  }

  40% {
    transform: rotate(-8deg);
  }

  60% {
    transform: rotate(5deg);
  }

  80% {
    transform: rotate(-5deg);
  }
`;



export const NotificationButton = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 9999px;
  cursor: pointer;
  color: #a1a1aa;
  transition: background-color 0.2s ease, color 0.2s ease;
 svg path{
  stroke:${({theme})=>theme.app.iconColor}
  }
  &:hover {
      background:${({theme})=>theme.app.iconHoverBg};
    color: ${({ theme }) => theme.app.text};
  }
  &:hover svg path {
    stroke: ${({ theme }) => theme.app.text};
  }
  &:hover svg {
    animation: ${bellShake} 1s ease-in-out;
    transform-origin: top center;
  }
`;